export const QUICK_AMOUNTS = [500, 1000, 2500, 5000, 10000];
